import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  accountProfileService,
  UpdateSelfProfileDto,
} from "@/services/accountProfileService";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";

export const accountKeys = {
  all: ["account"] as const,
  profile: () => [...accountKeys.all, "profile"] as const,
} as const;

export const useAccountProfile = () => {
  return useQuery({
    queryKey: accountKeys.profile(),
    queryFn: () => accountProfileService.getProfile(),
    staleTime: 5 * 60 * 1000,
  });
};

export const useUpdateProfile = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: (data: UpdateSelfProfileDto) =>
      accountProfileService.updateProfile(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: accountKeys.profile() });
      queryClient.invalidateQueries({ queryKey: ["userProfile"] });
      toast.success(t("account.general.profileUpdated"));
    },
    onError: () => {
      toast.error(t("account.general.profileUpdateError"));
    },
  });
};
